import dynamic from 'next/dynamic';

import { useWindowWidth } from '@virginexperiencedays/hooks';

import type { Product } from '@virginexperiencedays/products';
import type { CollectionChoiceDrawerModalSharedProps } from './types';
import {
  trackPdpCollectionChoice,
  PdpInteraction,
  PdpModules,
  type PdpInteractionProps,
} from '../../../../libs/tracking/pdp';

import { CollectionChoiceOverlayContent } from './CollectionChoiceOverlayContent';

const CollectionChoiceDrawer = dynamic<CollectionChoiceDrawerModalSharedProps>(
  () => import('./CollectionChoiceDrawer').then((mod) => mod.CollectionChoiceDrawer),
  { ssr: false }
);
const CollectionChoiceModal = dynamic<CollectionChoiceDrawerModalSharedProps>(
  () => import('./CollectionChoiceModal').then((mod) => mod.CollectionChoiceModal),
  { ssr: false }
);

export type CollectionChoiceOverlayProps = {
  product?: Product;
  trackingData?: PdpInteractionProps;
  isLoadingCollectionChoiceInfo: boolean;
} & CollectionChoiceDrawerModalSharedProps;

export const CollectionChoiceOverlay = ({
  collectionTitle,
  product,
  isOpen,
  setIsOpen,
  onClose,
  trackingData,
  isLoadingCollectionChoiceInfo,
}: CollectionChoiceOverlayProps) => {
  const { isDesktop } = useWindowWidth();

  const closeOverlay = () => {
    if (trackingData) {
      trackPdpCollectionChoice({
        ...trackingData,
        module: PdpModules.CollectionChoiceOverlay,
        interaction: PdpInteraction.ClickCloseOverlay,
        collectionChoiceSlug: product?.slug,
        collectionChoiceTitle: product?.title,
      });
    }
    setIsOpen(false);
    onClose();
  };

  if (isDesktop()) {
    return (
      <CollectionChoiceModal
        collectionTitle={collectionTitle}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onClose={closeOverlay}
      >
        <CollectionChoiceOverlayContent
          onClose={closeOverlay}
          product={product}
          trackingData={trackingData}
          isLoadingCollectionChoiceInfo={isLoadingCollectionChoiceInfo}
        />
      </CollectionChoiceModal>
    );
  }

  return (
    <CollectionChoiceDrawer
      collectionTitle={collectionTitle}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onClose={closeOverlay}
    >
      <CollectionChoiceOverlayContent
        onClose={closeOverlay}
        product={product}
        trackingData={trackingData}
        isLoadingCollectionChoiceInfo={isLoadingCollectionChoiceInfo}
      />
    </CollectionChoiceDrawer>
  );
};
